import { action, makeObservable, observable } from 'mobx';

import { HomePageRootStore } from '../../index.store';
import { ConnectRootStore } from '../../utils/connectRootStore';

export class GlobalPopoutStore extends ConnectRootStore<HomePageRootStore> {
    @observable public navBurgerOpen = false;

    @observable public userLoginOpen = false;

    @observable public bizLoginOpen = false;

    @observable public signupOpen = false;

    constructor(rootStore: HomePageRootStore) {
        super(rootStore);
        makeObservable(this);
    }

    get anyGlobalPopout(): boolean {
        return this.navBurgerOpen || this.userLoginOpen || this.bizLoginOpen;
    }

    @action
    public toggleUserLoginModal(state?: boolean): void {
        if (typeof state === 'boolean') this.userLoginOpen = state;
        else this.userLoginOpen = !this.userLoginOpen;

        if (!this.userLoginOpen) this.root.loginStore.reset();
    }

    @action
    public toggleBizLoginModal(state?: boolean): void {
        if (typeof state === 'boolean') this.bizLoginOpen = state;
        else this.bizLoginOpen = !this.bizLoginOpen;

        if (!this.bizLoginOpen) this.root.loginStore.reset();
    }

    @action
    public toggleSignup(state?: boolean): void {
        if (typeof state === 'boolean') this.signupOpen = state;
        else this.signupOpen = !this.signupOpen;
    }

    @action
    public triggerSignUp(): void {
        this.toggleUserLoginModal(false);
        this.toggleBizLoginModal(false);
        this.toggleSignup(true);
    }

    @action
    public toggleNavBurger(state?: boolean): void {
        if (typeof state === 'boolean') this.navBurgerOpen = state;
        else this.navBurgerOpen = !this.navBurgerOpen;
    }
}
